import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";

customerCardStyles.selectButton = {
    variant: "secondary",
}